module.exports = __webpack_public_path__ + "media/Generate_Certificate.a15d2fb0.mp4";